// Google Ads Conversion Tracking for Account AW-11301645502

// 1. Contact Form Submission (Kontaktformular gesendet)
function trackContactFormSubmission(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
    'send_to': 'AW-11301645502/M3eKCLuar8YaENLY4ac_',
    'value': 1.0,
    'currency': 'EUR',
    'event_callback': callback
  });
  return false;
}

// 2. Phone Number Click (Klick Telefonnummer)
function trackPhoneClick() {
  gtag('event', 'conversion', {
    'send_to': 'AW-11301645502/hreyCL6ar8YaENLY4ac_',
    'value': 1.0,
    'currency': 'EUR'
  });
}

// 3. Email Click (Klick E-Mail)
function trackEmailClick() {
  gtag('event', 'conversion', {
    'send_to': 'AW-11301645502/5b_jCMGar8YaENLY4ac_',
    'value': 1.0,
    'currency': 'EUR'
  });
}

// Event Listeners for elements you can't modify directly

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('gads-conversions loaded');
  
  // Contact Form Event Listener with reload handling
  const contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      e.preventDefault(); // Prevent immediate form submission
      
      let formSubmitted = false; // Flag to prevent double submission
      
      // Track conversion with callback
      gtag('event', 'conversion', {
        'send_to': 'AW-11301645502/M3eKCLuar8YaENLY4ac_',
        'value': 1.0,
        'currency': 'EUR',
        'event_callback': function() {
          if (!formSubmitted) {
            formSubmitted = true;
            console.log('Form Event Submitted - Callback');
            e.target.submit();
          }
        }
      });
      
      // Fallback: submit form after 1 second if callback doesn't fire
      setTimeout(function() {
        if (!formSubmitted) {
          formSubmitted = true;
          console.log('Form Event Submitted - Fallback');
          e.target.submit();
        }
      }, 1000);
    });
  }
  
  // Phone number clicks - add event listeners to all phone links
  const phoneLinks = document.querySelectorAll('a[href^="tel:"]');
  phoneLinks.forEach(function(phoneLink) {
    phoneLink.addEventListener('click', function(e) {
      console.log('trackPhoneLink Klick');
      trackPhoneClick();
    });
  });
  
  // Email clicks - add event listeners to all email links
  const emailLinks = document.querySelectorAll('a[href^="mailto:"]');
  emailLinks.forEach(function(emailLink) {
    emailLink.addEventListener('click', function(e) {
      console.log('trackEmailLink Klick');
      trackEmailClick();
    });
  });
  
});